import { useEffect } from 'react';
import NProgress from 'nprogress';
import LoadingOverlay from 'src/components/common/LoadingOverlay';
import Typography from '@mui/material/Typography';

interface SuspenseLoaderProps {
  message?: string;
}

function SuspenseLoader({ message }: SuspenseLoaderProps) {
  useEffect(() => {
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  return (
    <LoadingOverlay open>
      {message && (
        <Typography
          variant="h5"
          sx={{
            mt: 3,
            color: 'text.secondary',
            textAlign: 'center',
            fontSize: { xs: 20, sm: 20, md: 20 }
          }}
        >
          {message}
        </Typography>
      )}
    </LoadingOverlay>
  );
}

export default SuspenseLoader;
